import initI18n from '@quicktools/shared-components/services/i18n';
import React from 'react';
import { AnalyticsScript, SingleToolsBootstrap } from '@quicktools/shared-components';

import translations from '../services/i18n/translation.json';

import type { AppProps } from 'next/app';

initI18n(translations);

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <AnalyticsScript />
      <SingleToolsBootstrap>
        <Component {...pageProps} />
      </SingleToolsBootstrap>
    </>
  );
}

export default MyApp;
